import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { corHGlobal } from '../servicio/config/config.module';
import { OrdenCompras } from '../Models/ordencompras-dto';
import { Subject, Observable } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
@Injectable({
  providedIn: 'root'
})
export class ServiceOrdenCompra {

  private actionUrl: string;
  private corsHeadersLocal: HttpHeaders;

  private userLoggedIn = new Subject<boolean>();

  constructor(private corhglobal: corHGlobal, private http: HttpClient, @Inject(LOCAL_STORAGE) private storage: WebStorageService) {
    this.actionUrl = environment.ROOT_URL + '/';
    this.corhglobal.cambioToken(this.storage.get("TOKEN"));
    this.corsHeadersLocal = corhglobal.CORSHEADERS;
    this.userLoggedIn.next(false);
  }
  
  public getConsultaOrdenCompraPendiente(orden: OrdenCompras) {
    return this.http.post<OrdenCompras>(this.actionUrl + 'ConsultaOrdenCompraPendiente', orden, { headers: this.corsHeadersLocal }).pipe(timeout(500000));
  }
  public getConsultaOrdenCompra(orden: OrdenCompras) {
    return this.http.post<OrdenCompras>(this.actionUrl + 'ConsultaOrdenCompra', orden, { headers: this.corsHeadersLocal }).pipe(timeout(500000));
  }

  public getReportePDF(orden: OrdenCompras) {
    return this.http.post(this.actionUrl + 'GenerarPDFPedido', orden, { headers: this.corsHeadersLocal, responseType: 'blob' }).pipe(timeout(500000));
  }

  public getReporteXML(orden: OrdenCompras) {
    return this.http.post(this.actionUrl + 'GenerarXMLPedido', orden, { headers: this.corsHeadersLocal, responseType: 'blob' }).pipe(timeout(500000));
  }

  public getConsultaProveedorParametro(orden: OrdenCompras) {
    return this.http.post<OrdenCompras>(this.actionUrl + 'ConsultaProveedorParametro', orden, { headers: this.corsHeadersLocal }).pipe(timeout(500000));
  }







  public getActualizarProveedor(orden: OrdenCompras) {
    return this.http.post<OrdenCompras>(this.actionUrl + 'actualizarProvee', orden, { headers: this.corsHeadersLocal });
  }

  public getProveedorParametro(orden: OrdenCompras) {
    return this.http.post<OrdenCompras>(this.actionUrl + 'proveedorParametro', orden, { headers: this.corsHeadersLocal });
  }
}
